<!-- SprintBeta -->
<ng-template #contentBeta>
  <div #contentRoot>
    <div class="row justify-content-between">
      <div class="col py-0">
        <b style="font-size: 15px">{{ ticket?.ticket_number_teorema }}</b>
      </div>

      <div class="col-auto">
        @if (ticket_developer && user !== ticket_developer) {
          <patron-badge color="secondary">
            {{ ticket_developer }}
          </patron-badge>
        }
      </div>

      <div class="col pr-0 py-0">
        <div class="row justify-content-end mr-0">
          <div class="col-auto pl-0 d-flex align-items-center">
            @if (ticket?.status?.description) {
              <patron-badge [color]="getStatusClass(ticket?.status?.description)">
                {{ ticket?.status?.description | slice: 0 : 15 }}
                @if (ticket?.status?.description?.length! > 15) {
                  <span>...</span>
                }
              </patron-badge>
            }
            @if (
              ticket_type_description == 'Chamada Tipo Problema' ||
              ticket_type_description ==
                'Chamada Defeito /
            Retrabalho'
            ) {
              <patron-icon
                class="text-danger ml-1"
                name="bi-bug-fill"
                size="lg"
                pTooltip="Defeito / Retrabalho"></patron-icon>
            }
            @if (ticket?.urgent) {
              <patron-icon
                class="text-danger ml-1"
                name="bi-exclamation-triangle-fill"
                size="lg"
                pTooltip="Urgente"></patron-icon>
            }
            @if (ticket?.type == 'L' || ticket?.release_situation == 'P') {
              <patron-icon
                class="text-primary ml-1"
                name="pi-lock"
                size="lg"
                pTooltip="Liberação pendente"></patron-icon>
            }
            @if (ticket?.status?.description === 'Teste não ok') {
              <patron-icon
                class="text-danger ml-1"
                name="bi-x-octagon-fill"
                size="lg"
                pTooltip="Teste não ok"></patron-icon>
            }
          </div>

          <!-- <div class="col-auto pl-0"
          *ngIf="(ticket_type_description == 'Chamada Tipo Problema') || (ticket_type_description == 'Chamada Defeito / Retrabalho')"
          title="Chamada Tipo Problema ou Chamada Defeito / Retrabalho">
          <span class="badge badge-danger">
            <i class="fa fa-bug"></i>
            <patron-icon class="text-danger" name="bi-bug-fill"></patron-icon>
          </span>
        </div> -->
        </div>
      </div>
    </div>

    @if (totalPoints && completedPoints && progressPercentage) {
      <div class="row mt-2">
        <div class="col-12">
          <patron-progress color="success" [value]="progressPercentage" [height]="12">
            <small>{{ completedPoints }} de {{ totalPoints }} ({{ progressPercentage }}%)</small>
          </patron-progress>
        </div>
      </div>
    }

    <span class="mb-2 mx-n3 fw-bold" style="font-size: 12px">{{ ticket?.customer_name }}</span>

    @if (ticket?.summary || ticket?.problem) {
      <p class="mb-1 mx-n3" style="font-size: 13px">
        {{ ticket?.summary || ticket?.problem | slice: 0 : 115 }}
        @if ((ticket?.summary || ticket?.problem)?.length! > 115) {
          <span>[...]</span>
        }
      </p>
    }

    <div class="mx-1">
      @if (ticket?.ticket_tags && ticket?.ticket_tags?.length) {
        <div class="row mt-1">
          @for (ticketTag of ticket?.ticket_tags; track ticketTag) {
            <div class="col-auto px-1">
              <patron-badge color="warning" class="mb-1">
                <patron-icon name="cil-tag" size="sm"></patron-icon>
                {{ ticketTag.tag ? ticketTag.tag.name : '' }}
              </patron-badge>
            </div>
          }
        </div>
      }
    </div>

    <div class="row w-100 justify-content-center align-items-center m-0">
      <div class="col-auto py-0 text-center mb-3">
        @if (ticket?.count_documents) {
          <div>
            <patron-icon name="bi-paperclip" pTooltip="Número de anexos"></patron-icon>
            {{ ticket?.count_documents }}
          </div>
        }
      </div>
    </div>
    @if (isBeta && tasksByDev?.length > 0) {
      @for (taskDev of tasksByDev; track taskDev; let i = $index) {
        <div>
          <patron-card
            [contentTemplate]="contentTask"
            [styleClass]="
              'mb-3 teste-card ticket-card surface-ground with-overlay cursor-pointer ' +
              getColorTaskCard()
            ">
            <ng-template #contentTask>
              <div class="card-content-overlay">
                <div class="row justify-content-between mb-3">
                  <div class="col py-0">
                    @if (task?.sequence || taskDev?.summary) {
                      <patron-badge styleClasses="mr-1" color="secondary">
                        {{ taskDev!!.sequence }} - {{ taskDev!!.summary | slice: 0 : 15 }}
                        @if (taskDev!!.summary.length! > 15) {
                          <span>...</span>
                        }
                      </patron-badge>
                    }
                  </div>
                  <div class="col pr-0 py-0">
                    <div class="row justify-content-end mr-0">
                      <div class="col-auto d-flex align-items-center">
                        @if (taskDev?.status?.description) {
                          <patron-badge [color]="getStatusClass(taskDev?.status?.description)">
                            {{ taskDev?.status?.description | slice: 0 : 15 }}
                            @if (taskDev?.status?.description?.length! > 15) {
                              <span>...</span>
                            }
                          </patron-badge>
                        }
                        @if (taskDev && taskDev.finished) {
                          <patron-icon
                            class="ml-1 text-success"
                            name="bi-check-circle-fill"
                            size="lg"
                            pTooltip="Concluída"></patron-icon>
                        }
                      </div>
                      <!-- <div class="col-auto pl-0"
                    *ngIf="(ticket_type_description == 'Chamada Tipo Problema') || (ticket_type_description == 'Chamada Defeito / Retrabalho')"
                    title="Chamada Tipo Problema ou Chamada Defeito / Retrabalho">
                    <span class="badge badge-danger">
                      <i class="fa fa-bug"></i>
                    </span>
                  </div> -->
                    </div>
                  </div>
                </div>
                @if (taskDev && (ticket?.summary || ticket?.problem) != taskDev?.description) {
                  <ul style="font-size: 13px">
                    <p>
                      {{ taskDev.description | slice: 0 : 150 }}
                      @if (taskDev?.description?.length! > 150) {
                        <span>...</span>
                      }
                    </p>
                  </ul>
                }
                @if (taskDev && !taskDev.finished) {
                  <div class="row align-items-center w-100 mr-0">
                    <div class="col py-0">
                      @if (isDevCanRead() && taskDev?.systems?.length) {
                        <patron-badge color="info">
                          {{ taskDev?.systems[0].description! | slice: 0 : 20 }}
                          @if (taskDev?.systems[0].description.length! > 20) {
                            <span>...</span>
                          }
                          @if (taskDev?.systems?.length && taskDev!.systems!.length! > 1) {
                            <span> + {{ taskDev!.systems!.length! - 1 }}</span>
                          }
                        </patron-badge>
                      }
                    </div>
                  </div>
                }
                <div class="row justify-content-between tc-user-icon text-center">
                  <div class="col py-0 d-flex align-items-center">
                    @if (userLog) {
                      <patron-badge color="danger">
                        <patron-icon name="pi-clock"></patron-icon> {{ userLog }}
                      </patron-badge>
                    }
                  </div>
                  <div class="col py-0">
                    @if (showDate) {
                      <patron-badge color="danger">
                        {{
                          taskDev?.original_expected_date || taskDev?.expected_date
                            | date: 'dd/MM/yyyy'
                        }}
                      </patron-badge>
                    }
                  </div>
                  @if (isDevCanRead() && taskDev && !taskDev.finished) {
                    <div class="col justify-content-end pr-0">
                      <div class="col-auto pr-0 d-flex align-items-center">
                        @if (taskDev?.difficulty) {
                          <patron-badge
                            class="mr-1"
                            [color]="difficultyBadgeColorByValue(taskDev?.difficulty)">
                            {{ difficultyLabelByValue(taskDev?.difficulty) }}
                          </patron-badge>
                        }
                        @if (
                          taskDev?.estimated_effort !== null &&
                          taskDev?.estimated_effort !== undefined
                        ) {
                          <patron-badge color="secondary">
                            {{ taskDev?.estimated_effort }}
                            {{ taskDev?.estimated_effort! > 1 ? 'pontos' : 'ponto' }}
                          </patron-badge>
                        }
                        <!-- <patron-icon class="pt-1 ms-1 me-1 text-success" *ngIf=" taskDev && taskDev.finished"
                  name="pi-check-circle" size="lg"></patron-icon> -->
                      </div>
                    </div>
                  }
                </div>
                <!-- <div *ngIf="taskDev && taskDev.finished" class="row justify-content-end">
          <div class="col-auto text-primary pt-1 pr-2">
            <patron-icon name="pi-check-circle" size="lg"></patron-icon>
          </div>
        </div> -->
              </div>
            </ng-template>
          </patron-card>
        </div>
      }
    } @else {
      @if (isBeta) {
        <div class="row justify-content-between mt-1 tc-user-icon">
          <div class="col py-0">
            @if (system?.description) {
              <patron-badge color="info">
                {{ system?.description! | slice: 0 : 20 }}
                @if (system?.description?.length! > 20) {
                  <span>...</span>
                }
              </patron-badge>
            }
          </div>
        </div>
        <div class="row justify-content-between mt-1 tc-user-icon">
          <div class="col py-0">
            @if (ticket_developer && !ticket?.userLog) {
              <patron-badge color="secondary">
                {{ ticket_developer }}
              </patron-badge>
            }
            @if (userLog) {
              <patron-badge color="danger">
                <patron-icon name="pi-clock"></patron-icon> {{ userLog }}
              </patron-badge>
            }
          </div>
          @if (ticket?.ticket_tags && ticket?.ticket_tags?.length) {
            <div class="row mt-1">
              @for (ticketTag of ticket?.ticket_tags; track ticketTag) {
                <div class="col-auto px-1">
                  <patron-badge color="warning">
                    <patron-icon name="cil-tag" size="sm"></patron-icon>
                    {{ ticketTag.tag ? ticketTag.tag.name : '' }}
                  </patron-badge>
                </div>
              }
            </div>
          }
        </div>
        <!-- </div>
</div> -->
      }
    }
  </div>

  @if (ticketTask.ticket?.ticket_number_teorema) {
    <app-sprint-context-menu
      [ticket]="ticketTask.ticket!"
      [target]="contentRoot"
      [readOnly]="readOnly"></app-sprint-context-menu>
  }

  <ng-content></ng-content>
</ng-template>
<!-- End SprintBeta -->

<!-- SprintDefault -->
<ng-template #contentDefault>
  <div #contentRoot>
    <div class="row justify-content-between">
      <div class="col py-0">
        <b style="font-size: 15px">{{ ticket?.ticket_number_teorema }}</b>
      </div>

      <div class="col-auto">
        @if (ticket_developer) {
          <patron-badge color="secondary">
            {{ ticket_developer }}
          </patron-badge>
        }
      </div>

      <div class="col pr-0 py-0">
        <div class="row justify-content-end mr-0">
          <div class="col-auto d-flex ali align-items-center">
            @if (ticket?.status?.description) {
              <patron-badge [color]="getStatusClass(ticket?.status?.description)">
                {{ ticket?.status?.description | slice: 0 : 15 }}
                @if (ticket?.status?.description?.length! > 15) {
                  <span>...</span>
                }
              </patron-badge>
            }
            @if (
              ticket_type_description == 'Chamada Tipo Problema' ||
              ticket_type_description ==
                'Chamada Defeito /
            Retrabalho'
            ) {
              <patron-icon
                class="text-danger ml-1"
                name="bi-bug-fill"
                size="lg"
                pTooltip="Defeito / Retrabalho"></patron-icon>
            }
            @if (ticket?.urgent) {
              <patron-icon
                class="text-danger ml-1"
                name="bi-exclamation-triangle-fill"
                size="lg"
                pTooltip="Urgente"></patron-icon>
            }
            @if (ticket?.type == 'L' || ticket?.release_situation == 'P') {
              <patron-icon
                class="text-primary ml-1"
                name="pi-lock"
                size="lg"
                pTooltip="Liberação pendente"></patron-icon>
            }
            @if (ticket?.status?.description === 'Teste não ok') {
              <patron-icon
                class="text-danger ml-1"
                name="bi-x-octagon-fill"
                size="lg"
                pTooltip="Teste não ok"></patron-icon>
            }
          </div>

          <!-- <div class="col-auto pl-0"
          *ngIf="(ticket_type_description == 'Chamada Tipo Problema') || (ticket_type_description == 'Chamada Defeito / Retrabalho')"
          title="Chamada Tipo Problema ou Chamada Defeito / Retrabalho">
          <span class="badge badge-danger">
            <i class="fa fa-bug"></i>
          </span>
        </div> -->
        </div>
      </div>
    </div>

    @if (totalPoints && completedPoints && progressPercentage) {
      <div class="row mt-2">
        <div class="col-12">
          <patron-progress color="success" [value]="progressPercentage" [height]="12">
            <small>{{ completedPoints }} de {{ totalPoints }} ({{ progressPercentage }}%)</small>
          </patron-progress>
        </div>
      </div>
    }

    <span class="mb-2 mx-n3" style="font-size: 12px">{{ ticket?.customer_name }}</span>

    @if (ticket?.summary || ticket?.problem) {
      <p class="mb-1 mx-n3" style="font-size: 13px">
        {{ ticket?.summary || ticket?.problem | slice: 0 : 115 }}
        @if ((ticket?.summary || ticket?.problem)?.length! > 115) {
          <span>[...]</span>
        }
      </p>
    }
    @if (task && (ticket?.summary || ticket?.problem) != task.description) {
      <ul style="font-size: 13px">
        <li>
          @if (task.sequence || task.summary) {
            <patron-badge styleClasses="mr-1" color="secondary">
              {{ task!!.sequence }} - {{ task!!.summary }}
            </patron-badge>
          }
          {{ task.description | slice: 0 : 150 }}
          @if (task.description?.length! > 150) {
            <span>...</span>
          }
        </li>
      </ul>
    }

    <div class="row align-items-center w-100 mr-0">
      <!-- <div class="col py-0">
    <div class="row">

      <div *ngFor="let system of systems" class="col-auto py-0 mb-3">
        <patron-badge
          *ngIf="system?.description"
          color="info"
          >
          {{system?.description! | slice: 0:20}}
          <span *ngIf="system?.description?.length! > 20">...</span>
        </patron-badge>
      </div>

    </div>
  </div> -->

      <div class="col py-0">
        @if (system?.description) {
          <patron-badge color="info">
            {{ system?.description! | slice: 0 : 20 }}
            @if (system?.description?.length! > 20) {
              <span>...</span>
            }
            @if (task?.systems?.length && task!.systems!.length! > 1) {
              <span> + {{ task!.systems!.length! - 1 }}</span>
            }
          </patron-badge>
        }
      </div>

      <div class="col-auto py-0">
        @if (ticket?.count_documents) {
          <div>
            <patron-icon name="bi-paperclip" pTooltip="Número de anexos"></patron-icon>
            {{ ticket?.count_documents }}
          </div>
        }
      </div>

      <div class="col py-0 pr-0">
        @if (task?.difficulty) {
          <div class="row justify-content-end">
            <div class="col-auto py-0 pr-0">
              <patron-badge [color]="difficultyBadgeColor">
                {{ difficultyLabel }}
              </patron-badge>
            </div>
          </div>
        }
      </div>
    </div>

    <div class="row justify-content-between mt-1 tc-user-icon">
      <div class="col py-0">
        @if (task?.user?.name && !ticket?.userLog) {
          <patron-badge color="secondary">
            {{ task?.user?.name }}
          </patron-badge>
        }
        @if (userLog) {
          <patron-badge color="danger">
            <patron-icon name="pi-clock"></patron-icon> {{ userLog }}
          </patron-badge>
        }
      </div>

      <div class="col py-0 text-center">
        @if (showDate) {
          <patron-badge color="danger">
            {{ task?.original_expected_date || task?.expected_date | date: 'dd/MM/yyyy' }}
          </patron-badge>
        }
      </div>

      <div class="col py-0 text-right">
        @if (task?.estimated_effort !== null && task?.estimated_effort !== undefined) {
          <patron-badge color="secondary">
            {{ task?.estimated_effort }} {{ task?.estimated_effort! > 1 ? 'pontos' : 'ponto' }}
          </patron-badge>
        }
      </div>
    </div>

    <div class="mx-1">
      @if (ticket?.ticket_tags && ticket?.ticket_tags?.length) {
        <div class="row mt-1">
          @for (ticketTag of ticket?.ticket_tags; track ticketTag) {
            <div class="col-auto px-1">
              <!-- <patron-badge color="warning">
          <patron-icon name="cil-tag" size="sm"></patron-icon> {{ticketTag.tag ? ticketTag.tag.name : ''}} -->
              <patron-badge color="warning">
                <patron-icon name="bi-tag" size="sm"></patron-icon>
                {{ ticketTag.tag ? ticketTag.tag.name : '' }}
              </patron-badge>
            </div>
          }
        </div>
      }
    </div>

    @if (task && task.finished) {
      <div class="row justify-content-end">
        <div class="col-auto text-primary pt-1 pr-2">
          <patron-icon name="pi-check-circle" size="lg" pTooltip="Concluída"></patron-icon>
        </div>
      </div>
    }
  </div>

  @if (ticketTask.ticket?.ticket_number_teorema) {
    <app-sprint-context-menu
      [ticket]="ticketTask.ticket!"
      [target]="contentRoot"
      [readOnly]="readOnly"></app-sprint-context-menu>
  }

  <ng-content></ng-content>
</ng-template>
<!-- End SprintDefault -->

<patron-card
  [contentTemplate]="isBeta ? contentBeta : contentDefault"
  [styleClass]="'mb-3 ticket-card cursor-pointer ' + tcTicketService.getColor(color, 'alert-')"
  (click)="click.emit($event)">
</patron-card>
